import { render, staticRenderFns } from "./SalesApprovals.vue?vue&type=template&id=a940c3bc"
import script from "./SalesApprovals.vue?vue&type=script&lang=js"
export * from "./SalesApprovals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports